import Tip from './Tip.vue';

Tip.install = (Vue) => {
  Vue.component(Tip.name, Tip);
};

export default Tip;
